import React from 'react';
import { Text, View, Avatar } from '@constants/Themed';
import Button from '@components/UI/Button/Button';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { getModernCardStyle, getModernTextColor, getModernActionStyle } from '@stylesheet';
import * as Animatable from 'react-native-animatable';

const RequestItem = ({ request, onAccept, onReject }) => {
  const theme = themeSelector();

  return (
    <Animatable.View
      animation="fadeInUp"
      duration={300}
      style={[
        getModernCardStyle(theme, 'medium'),
        {
          marginVertical: 8,
          marginHorizontal: 4,
          padding: 20,
          minHeight: 120,
        }
      ]}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 16 }}>
        {/* Avatar Container */}
        <Animatable.View
          animation="bounceIn"
          delay={100}
          style={{
            width: 56,
            height: 56,
            borderRadius: 28,
            backgroundColor: theme ? 'rgba(90, 192, 234, 0.1)' : 'rgba(90, 192, 234, 0.2)',
            alignItems: 'center',
            justifyContent: 'center',
            borderWidth: 2,
            borderColor: theme ? 'rgba(90, 192, 234, 0.3)' : 'rgba(90, 192, 234, 0.4)',
          }}
        >
          <Avatar
            src={request.avatar}
            alt={request.user}
            size={48}
          >
            {request.user}
          </Avatar>
        </Animatable.View>

        {/* Content Container */}
        <View style={{ flex: 1, gap: 8 }}>
          <Animatable.Text
            animation="slideInDown"
            style={{
              fontSize: 16,
              fontWeight: '600',
              color: getModernTextColor(theme, 'primary'),
              lineHeight: 22,
            }}
          >
            <Text style={{ fontWeight: '700', color: getModernTextColor(theme, 'primary') }}>
              {request.user}
            </Text>
            {' '}sent you a friend request
          </Animatable.Text>

          <Text
            style={{
              fontSize: 13,
              color: getModernTextColor(theme, 'muted'),
              fontWeight: '500',
            }}
          >
            {request.time} ago
          </Text>

          {/* Action Buttons */}
          <View style={{
            flexDirection: 'row',
            gap: 12,
            marginTop: 8,
            alignItems: 'center',
          }}>
            <Animatable.View
              animation="bounceIn"
              delay={200}
              style={{ flex: 1 }}
            >
              <Button
                customStyle={[
                  getModernActionStyle(theme, 'green'),
                  {
                    borderRadius: 12,
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    minHeight: 44,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }
                ]}
                buttonText="Accept"
                onPress={onAccept}
              />
            </Animatable.View>

            <Animatable.View
              animation="bounceIn"
              delay={300}
              style={{ flex: 1 }}
            >
              <Button
                customStyle={[
                  getModernActionStyle(theme, 'red'),
                  {
                    borderRadius: 12,
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    minHeight: 44,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }
                ]}
                buttonText="Decline"
                onPress={onReject}
              />
            </Animatable.View>
          </View>
        </View>
      </View>
    </Animatable.View>
  );
}
export default RequestItem;